var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({ref:"select",model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.getDictionary(_vm.dictType)),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.label,"value":item.key}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }